import { isRealCurrency } from 'utils/currency';

export type GridCurrencyMismatch =
    | {
          errorKey: 'PRICE_LIST_ORDER_CURRENCY_MISMATCH';
          values: { priceListCurrency: string; orderCurrency: string };
      }
    | {
          errorKey: 'ACTION_MATERIAL_CURRENCY_MISMATCH';
          values: { actionCurrency: string; materialCurrency: string };
      }
    | undefined;

// An order is priced in one currency, and rows added on order details take their prices from a
// price list. That list's currency must match the order's; while the order has no currency yet,
// it must match the currency the other grid has already resolved into the shared context
// (for action-based orders that is the clinic's lab connection, which wins over material lists).
export const getGridCurrencyMismatch = (
    side: 'action' | 'material',
    orderCurrency: string | undefined,
    contextCurrency: string,
    priceListCurrency: string | null | undefined,
): GridCurrencyMismatch => {
    if (!priceListCurrency) {
        return undefined;
    }
    if (isRealCurrency(orderCurrency)) {
        if (priceListCurrency === orderCurrency) {
            return undefined;
        }
        return { errorKey: 'PRICE_LIST_ORDER_CURRENCY_MISMATCH', values: { priceListCurrency, orderCurrency } };
    }
    if (!isRealCurrency(contextCurrency) || priceListCurrency === contextCurrency) {
        return undefined;
    }
    const values =
        side === 'action'
            ? { actionCurrency: priceListCurrency, materialCurrency: contextCurrency }
            : { actionCurrency: contextCurrency, materialCurrency: priceListCurrency };
    return { errorKey: 'ACTION_MATERIAL_CURRENCY_MISMATCH', values };
};
